import { getIsoDateWithoutTz } from '@shared/helpers/date';
import endOfMonth from 'date-fns/endOfMonth';

export const getDateToExtend = ({ selectedDate }: { selectedDate: string }): string => {
  const extendDate = endOfMonth(new Date(selectedDate));

  return getIsoDateWithoutTz(extendDate);
};
